var map = {
	"./b_b.png": 85,
	"./b_w.png": 86,
	"./k_b.png": 87,
	"./k_w.png": 88,
	"./n_b.png": 89,
	"./n_w.png": 90,
	"./p_b.png": 91,
	"./p_w.png": 92,
	"./q_b.png": 93,
	"./q_w.png": 94,
	"./r_b.png": 95,
	"./r_w.png": 96
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;